<div class="theme-container" [ngClass]="{ 'dark-theme': isDarkTheme, 'light-theme': !isDarkTheme }">
    <button class="theme-toggle-button" [ngClass]="{'toggled': isDarkTheme}" (click)="toggleTheme()">
      Switch to {{ isDarkTheme ? 'Light' : 'Dark' }} Theme
    </button>
  
    <app-loader class="app-loader"></app-loader>
    <router-outlet></router-outlet>
  </div>
